/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signingin1Inputs */

const zh_auth_signingin1 = /** @type {(inputs: Auth_Signingin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录中...`)
};

const en_auth_signingin1 = /** @type {(inputs: Auth_Signingin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in...`)
};

const es_auth_signingin1 = /** @type {(inputs: Auth_Signingin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión...`)
};

/**
* | output |
* | --- |
* | "Signing in..." |
*
* @param {Auth_Signingin1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signingin1 = /** @type {((inputs?: Auth_Signingin1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signingin1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signingin1(inputs)
	if (locale === "en") return en_auth_signingin1(inputs)
	return es_auth_signingin1(inputs)
});
export { auth_signingin1 as "auth_signingIn" }